module.exports = __webpack_public_path__ + "7217ea533ad1ddcb4663f79f57d1dc9e.woff2";